// Migration wizard polling: inventory annotations on the new page, item
// progress on the show page. Both loops run on the shared poller engine —
// timers are torn down on Turbolinks navigation and every loop carries a
// budget, so neither can outlive its page or poll a stalled run forever.
import {
  SPINNER_HTML,
  escapeText,
  createStatusPoller,
} from "../../../components/live_status"
import { enableRangeSelect } from "../../../components/range_select"

// The inventory loop also stops after ~2 minutes of nothing arriving (job
// never started: scanner down, Sidekiq stopped) instead of polling forever.
var INVENTORY_MAX_POLLS = 30
var inventoryPending = true
var progressActive = true

$(document).on("turbolinks:load", function () {
  if (document.getElementById("js-migration-form")) {
    inventoryPending = true
    syncFileMaster()
    recommend()
    inventoryPoller.start()
  }
  if (document.getElementById("js-migration-page")) {
    progressActive = true
    progressSnapshot = null
    itemsSnapshot = null
    assetsSnapshot = null
    confirmSnapshot = null
    actionsSnapshot = null
    progressPoller.start()
  }
})

$(document).on("turbolinks:before-cache turbolinks:visit", function () {
  inventoryPoller.stop()
  progressPoller.stop()
})

// --- New page: inventory annotations + destination recommendation ----------

var destinationTouched = false

$(document).on("change", ".js-migration-file", function () {
  syncFileMaster()
  recommend()
})

// Some products carry hundreds of files — the header checkbox toggles every
// selectable row at once, and shift+click sweeps ranges.
enableRangeSelect(".js-migration-file")

$(document).on("change", ".js-migration-file-all", function () {
  $(".js-migration-file").not(":disabled").prop("checked", this.checked)
  syncFileMaster()
  recommend()
})

// The header box mirrors the rows honestly: checked when every selectable
// file is included, indeterminate for a partial selection. Over-cap rows are
// disabled and never count.
function syncFileMaster() {
  var master = document.querySelector(".js-migration-file-all")
  if (!master) return

  var boxes = $(".js-migration-file").not(":disabled").toArray()
  var checked = boxes.filter(function (box) {
    return box.checked
  }).length
  master.checked = boxes.length > 0 && checked === boxes.length
  master.indeterminate = checked > 0 && checked < boxes.length
}
$(document).on("click", ".js-destination", function () {
  destinationTouched = true
})

// Reaching for the library dropdown IS choosing the existing-library
// destination — check its radio and stop the recommendation from flipping
// the choice away afterwards.
$(document).on("focus change", ".js-existing-library", function () {
  var radio = document.getElementById("dest-existing")
  if (radio && !radio.checked) radio.checked = true
  destinationTouched = true
})

// "Top-level collections only" belongs to collections mode alone; the
// checkbox greys out (and unchecks) under any other marking mode.
$(document).on("change", ".js-marking-mode", function () {
  var box = document.querySelector(".js-top-level-collections")
  if (!box) return

  var enabled = this.value === "collections" && this.checked
  box.disabled = !enabled
  if (!enabled) box.checked = false
})

function recommend() {
  var form = document.getElementById("js-migration-form")
  if (!form || destinationTouched) return

  var threshold = parseInt(
    form.getAttribute("data-library-threshold") || "5",
    10
  )
  var total = 0
  document
    .querySelectorAll(".js-migration-file:checked")
    .forEach(function (box) {
      total += parseInt(box.getAttribute("data-estimate") || "0", 10)
    })
  var target = document.getElementById(
    total > threshold ? "dest-library" : "dest-individual"
  )
  if (target) target.checked = true
}

var inventoryPoller = createStatusPoller({
  page: function () {
    return document.getElementById("js-migration-form")
  },
  interval: 4000,
  immediate: true,
  maxPolls: INVENTORY_MAX_POLLS,
  hasPending: function () {
    return inventoryPending
  },
  url: function () {
    return document
      .getElementById("js-migration-form")
      .getAttribute("data-inventory-url")
  },
  onBudgetExhausted: function () {
    document.querySelectorAll(".js-inventory-note").forEach(function (note) {
      if (note.textContent.indexOf("analyzing") !== -1) {
        note.textContent = "couldn't analyze — you can still migrate"
      }
    })
  },
  onResults: function (rows) {
    var pending = rows.length === 0
    rows.forEach(function (row) {
      var note = document.querySelector(
        '.js-inventory-note[data-download-id="' + row.download_id + '"]'
      )
      var inFlight = row.status !== "done" && row.status !== "error"
      if (note)
        note.innerHTML = (inFlight ? SPINNER_HTML : "") + escapeText(row.note)
      var box = document.querySelector(
        '.js-migration-file[value="' + row.download_id + '"]'
      )
      if (box) box.setAttribute("data-estimate", row.estimate)
      if (inFlight) pending = true
    })
    recommend()
    inventoryPending = pending
    return false
  },
})

// --- Show page: item progress ------------------------------------------------

var ACTIVE = ["pending", "running", "awaiting_input"]

// Generous: big zip batches scan for a long time, and any status/count
// movement resets the budget — only a run where nothing changes for ~10
// minutes stops polling.
var PROGRESS_MAX_POLLS = 150
var progressSnapshot = null
var itemsSnapshot = null
var assetsSnapshot = null
var confirmSnapshot = null
var actionsSnapshot = null

var progressPoller = createStatusPoller({
  page: function () {
    return document.getElementById("js-migration-page")
  },
  interval: 4000,
  immediate: true,
  maxPolls: PROGRESS_MAX_POLLS,
  hasPending: function () {
    return progressActive
  },
  url: function () {
    return document
      .getElementById("js-migration-page")
      .getAttribute("data-statuses-url")
  },
  onResults: function (data) {
    // Item statuses/errors ride in the snapshot too: a parked zip child can
    // change an item line without moving any count.
    var snapshot = JSON.stringify([
      data.status,
      data.counts,
      data.items.map(function (item) {
        return [item.status, item.error]
      }),
    ])
    var progressed = snapshot !== progressSnapshot
    progressSnapshot = snapshot

    renderProgress(data, progressed)
    progressActive = ACTIVE.indexOf(data.status) !== -1
    return progressed
  },
})

// Matches Rails' .humanize on the server-rendered statuses, so labels don't
// visibly re-case when the first poll lands.
function humanizeStatus(status) {
  var text = status.replace(/_/g, " ")
  return text.charAt(0).toUpperCase() + text.slice(1)
}

function renderProgress(data, progressed) {
  var page = document.getElementById("js-migration-page")
  // Quiet polls leave the DOM alone — rebuilding identical content every 4s
  // disrupts text selection and re-fires the aria-live regions.
  if (progressed) {
    page.querySelector(".js-migration-status").textContent = humanizeStatus(
      data.status
    )
    // Server-built sentence (shared with the initial render) — textContent
    // only, so the aria-live region announces one line, never markup churn.
    page.querySelector(".js-migration-summary").textContent = data.summary
  }

  // The item table, created assets, the replace-conflict prompt, and the
  // post-run actions all arrive server-rendered from the same partials as
  // the initial page; the snapshot compares keep them (and their
  // thumbnails/buttons) from re-rendering on every quiet poll.
  swapFragment(page, ".js-migration-items", data.items_html, {
    get: function () {
      return itemsSnapshot
    },
    set: function (value) {
      itemsSnapshot = value
    },
  })
  swapFragment(page, ".js-migration-assets", data.assets_html, {
    get: function () {
      return assetsSnapshot
    },
    set: function (value) {
      assetsSnapshot = value
    },
  })
  // Never rebuild buttons out from under a user about to click them — hold
  // the swap while focus is inside (snapshot stays stale, so the next quiet
  // poll retries). The actions block arrives empty while the run is active
  // and fills in — with a fresh delete-originals count — when it settles.
  swapFragment(page, ".js-migration-confirm", data.confirmation_html, {
    get: function () {
      return confirmSnapshot
    },
    set: function (value) {
      confirmSnapshot = value
    },
  })
  swapFragment(page, ".js-migration-actions", data.actions_html, {
    get: function () {
      return actionsSnapshot
    },
    set: function (value) {
      actionsSnapshot = value
    },
  })
}

function swapFragment(page, selector, html, snapshot) {
  var box = page.querySelector(selector)
  if (
    !box ||
    typeof html !== "string" ||
    html === snapshot.get() ||
    box.contains(document.activeElement)
  )
    return

  snapshot.set(html)
  box.innerHTML = html
}
